import React from "react";
import "./LoadingText.css";

export default function LoadingText() {
  return (
    <span className="text-container">
      <div className="loading-text"></div>
    </span>
  );
}